import Form from './form';
// Filed types
import Group from './group';
import TextField from './text-field';
import ArrayField from './array-field';
import ObjectField from './object-field';
import NumberField from './number-field';
import FileUploadField from './file-upload';
// import ColorField from "./color-field";
// import ImageField from "./image-field";
import { DateTimeField, DateField, TimeField } from './date-field';
import If from './if';
import ToggleField from './toggle-field';
import AutoCompleteField from './auto-complete';
import CheckboxField, { CheckboxGroupField } from './checkbox';
import RadioField, { RadioGroupField } from './radio';
import { SelectField, SelectDivider, SelectItemField } from './select';
import VimeoField from './vimeo-field';
import YouTubeField from './youtube-field';

export default Form;

export {
  ArrayField,
  AutoCompleteField,
  CheckboxField,
  CheckboxGroupField,
  FileUploadField,
  // ColorField,
  DateField,
  DateTimeField,
  Group,
  If,
  // ImageField,
  NumberField,
  ObjectField,
  RadioField,
  RadioGroupField,
  SelectDivider,
  SelectField,
  SelectItemField,
  TextField,
  TimeField,
  ToggleField,
  VimeoField,
  YouTubeField
};
